"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_system_1 = require("styled-system");
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var stylePacks_1 = require("../styles/stylePacks");
var StyledSelect = (0, styled_1.default)(Box_1.default)((0, styled_system_1.variant)({ scale: 'selects' }));
StyledSelect.defaultProps = { as: 'select' };
var Select = react_1.default.forwardRef(function (props, ref) {
    var children = props.children, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, rest = __rest(props, ["children", "onChange", "onFocus", "onBlur"]);
    var _a = (0, react_1.useState)(false), isFocus = _a[0], setIsFocus = _a[1];
    /* -------------------------- version 2 ---------------------------- */
    if (props.variant === 'v2') {
        return (react_1.default.createElement(Box_1.default, { position: 'relative' },
            react_1.default.createElement(StyledSelect, __assign({}, rest, { onChange: onChange, 
                // eslint-disable-next-line
                ref: ref }), children),
            react_1.default.createElement(ArrowV2, null)));
    }
    /* -------------------------- version 1 ---------------------------- */
    return (
    // have to use a styled TransitionBox instead of styling select directly,
    // because Select will have opacity 0 for floating label to not overlap with it
    react_1.default.createElement(TransitionBox, { isFocus: isFocus },
        react_1.default.createElement(StyledSelect, __assign({}, rest, { onFocus: function (event) {
                setIsFocus(true);
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
            }, onBlur: function (event) {
                setIsFocus(false);
                onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
            }, onChange: onChange, 
            // eslint-disable-next-line
            ref: ref }), children),
        react_1.default.createElement(Arrow, null)));
});
Select.displayName = 'Select';
Select.defaultProps = {
    variant: 'primary'
};
// eslint-disable-next-line
var inputFocusStyle = stylePacks_1.inputTransition[':focus'];
if (!inputFocusStyle)
    throw new Error('input focus style is missing');
var TransitionBox = (0, styled_1.default)(Box_1.default)(function (_a) {
    var isFocus = _a.isFocus;
    return (__assign(__assign({ position: 'relative' }, stylePacks_1.inputTransition), (isFocus && inputFocusStyle)));
});
var Arrow = (0, styled_1.default)(Box_1.default)({
    position: 'absolute',
    top: '42%',
    right: '4px',
    borderStyle: 'solid',
    borderWidth: '0 1px 1px 0',
    padding: '3px',
    transform: 'rotate(45deg)'
});
var ArrowV2 = (0, styled_1.default)(Box_1.default)({
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderTop: '6px solid #171A20',
    height: 0,
    pointerEvents: 'none',
    position: 'absolute',
    right: '19px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 0,
});
exports.default = Select;
